<template>
  <div>
    <a
      class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold cursor-pointer"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <i class="text-white fas fa-truck text-lg leading-lg mr-2"></i>
      DVCommand
      <i class="fas fa-chevron-down ml-1 text-xs"></i>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <router-link
        to="/dvcommand"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:bg-blueGray-100"
        @click="closeDropdown"
      >
        DVCommand Overview
      </router-link>
      <router-link
        to="/pumplink7"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:bg-blueGray-100"
        @click="closeDropdown"
      >
        pumpLink7
      </router-link>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
    },
  },
};
</script>